import { ArrayData, SystemData } from ".";
import { InverterTypeModel } from "./InverterTypeModel";
import { SystemComponent } from "../Customer/SystemComponent";

export interface ISystemDetails extends SystemData.ISystemData {
  igsCustomerNumber: string;
  installStartDate: Date;
  installCompleteDate: Date;
  moduleQuantity: number;
  module: string;
  moduleWattage: number;
  inverter1: string;
  inverter2: string;
  racking: string;
  meter: string;
  p50AnnualProduction: number;
  name: string;
  systemSize: number;
  systemId?: number;
  isLineTrenchingRequired: boolean;
  shadeReportName: string;
}

export class SystemDetails implements ISystemDetails {
  public arrayDataDetails: ArrayData.ArrayData[];
  public systemComponents: SystemComponent[];
  /** @deprecated SOL-5982 (maybe) */
  public igsCustomerNumber: string;
  public installStartDate: Date;
  public installCompleteDate: Date;
  public moduleQuantity: number;
  public module: string;
  public moduleWattage: number;
  public inverter1: string;
  public inverter2: string;
  public racking: string;
  public meter: string;
  public inverterType: InverterTypeModel;
  public p50AnnualProduction: number;
  public name: string;
  public systemSize: number;
  public systemId?: number;
  public isLineTrenchingRequired: boolean
  public shadeReportName: string;
}
